import React, { useEffect } from "react";
import ProgressProvider from "../providers/progressProvider";
import { useQuestionContext } from "../providers/questionProvider";
import Scroll from "../../../partials/Scroll/Scroll";
import "./QuestionBox.scss";

function QuestionBox({messages, showBox}) {
  const { questionOpen, selectedQuestion, currentAnswer, setQuestionOpen } =
    useQuestionContext();

  const handleClose = () => {
    console.log("handleClose" ); 
      setQuestionOpen(false);     
  }; 

  useEffect(() => {
    setQuestionOpen(false);    
  }, [showBox]);

  const continueCaption =
    currentAnswer && currentAnswer.isCorrect
      ? messages?.successAnswered
      : messages?.errorAnswered;

  if (questionOpen === false) return null;

  function setMarkup(content) {
    if (typeof content === "string") {
      return { __html: content };
    }
    return null;
  }

  const continueBtn = (
    <div className="missionelements_Modal_actions">
      <button
        className="global-button "
        style={{ backgroundColor: "#131821" }}
        onClick={() => {
          handleClose()   
        }}
      >
        {continueCaption || "CLOSE"}
      </button>
    </div>
  );

  return (
    <Scroll className="questionScroll">
      <div className={`qBox`}>
        <div dangerouslySetInnerHTML={setMarkup(selectedQuestion)} />
        {typeof selectedQuestion === "object" && selectedQuestion}
        {currentAnswer && continueBtn}
      </div>
    </Scroll>
  );
}

export default QuestionBox;
